"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var models_1 = require("./models");
var BhtpEligibilityService = BhtpEligibilityService_1 = (function (_super) {
    __extends(BhtpEligibilityService, _super);
    function BhtpEligibilityService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    BhtpEligibilityService.getRecommendationMessage = function (messages) {
        return messages.find(function (m) { return m.type === models_1.ApiMessageType.Recommendation; });
    };
    BhtpEligibilityService.getRecommendedQuote = function (recommendationMessage, eligibleQuotes) {
        if (recommendationMessage) {
            var recommendedPackageRatingId_1 = BhtpEligibilityService_1.parseRecommendationCode(recommendationMessage);
            if (recommendedPackageRatingId_1 !== null && recommendationMessage !== undefined) {
                return eligibleQuotes.find(function (p) { return p.package.ratingId === recommendedPackageRatingId_1; });
            }
        }
        return null;
    };
    // returns the package rating id recommended by the message code
    BhtpEligibilityService.parseRecommendationCode = function (message) {
        if (message && message.code) {
            // recommendation messages start with an 8, the remainder is the package rating id
            var remainder = message.code.substr(1);
            var tempValue = parseInt(remainder);
            return tempValue.toString();
        }
        return null;
    };
    BhtpEligibilityService.prototype.searchFlights = function (flight) {
        var path = this.getFullUrl("/Flight/Schedule");
        var body = JSON.stringify(flight);
        var options = this.getStandardRequestOptions();
        return this.http.post(path, body, options).map(function (res) {
            return res.json();
        }).catch(this.handleError);
    };
    BhtpEligibilityService.prototype.verifyFlights = function (flights) {
        var path = this.getFullUrl("/Flight");
        return this.sendFlightsRequest(flights, path);
    };
    BhtpEligibilityService.prototype.verifyFlightsByPackage = function (flights, packageRatingId) {
        var path = this.getFullUrl("/FlightPerPackage?packageRatingId=" + packageRatingId);
        return this.sendFlightsRequest(flights, path);
    };
    BhtpEligibilityService.prototype.verifyFlightsByPackageWithRecommendations = function (flights, travelers, acknowledgements, packageRatingId, tripDepartureDate, tripReturnDate, eligibilityToken) {
        var path = this.getFullUrl("/FlightCheckRecommendations?packageRatingId=" + packageRatingId);
        var request = new models_1.ApiFlightCheckRequest();
        request.flights = flights;
        request.travelers = this.buildPersonListFromTravelers(travelers);
        request.acknowledgements = acknowledgements;
        request.tripDepartureDate = tripDepartureDate;
        request.tripReturnDate = tripReturnDate;
        request.eligibilityToken = eligibilityToken;
        var primaryTraveler = travelers.find(function (t) { return t.isPrimary; });
        if (primaryTraveler) {
            request.primaryTravelerAddress = primaryTraveler.address;
        }
        return this.http.post(path, JSON.stringify(request), this.getStandardRequestOptions()).map(function (res) {
            return res.json();
        }).catch(this.handleError);
    };
    BhtpEligibilityService.prototype.verifyTravelers = function (travelers) {
        var path = this.getFullUrl("/PersonList");
        var eligibilityPersonList = this.buildPersonListFromTravelers(travelers);
        var body = JSON.stringify(eligibilityPersonList);
        var options = this.getStandardRequestOptions();
        return this.http.post(path, body, options).map(function (res) {
            return res.json();
        }).catch(this.handleError);
    };
    BhtpEligibilityService.prototype.sendFlightsRequest = function (flights, uri) {
        var body = JSON.stringify(flights);
        var options = this.getStandardRequestOptions();
        return this.http.post(uri, body, options).map(function (res) {
            var flightResponse = res.json();
            return flightResponse;
        }).catch(this.handleError);
    };
    BhtpEligibilityService.prototype.buildPersonListFromTravelers = function (travelers) {
        var eligibilityPersonList = [];
        travelers.forEach(function (traveler, index) {
            var eligibilityPerson = models_1.ApiEligibilityPerson.fromApiTraveler(traveler, index);
            eligibilityPersonList.push(eligibilityPerson);
        });
        return eligibilityPersonList;
    };
    return BhtpEligibilityService;
}(base_1.BhtpBaseService));
BhtpEligibilityService = BhtpEligibilityService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpEligibilityService);
exports.BhtpEligibilityService = BhtpEligibilityService;
var BhtpEligibilityService_1;
//# sourceMappingURL=D:/a/1/s/eligibility/src/eligibility-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/eligibility-service.js